export default __webpack_public_path__ + "static/media/tractor.41e37ccc.jpg";